import { CampaignMedium } from '@prisma/client';
import { toast } from 'react-toastify';
import { Add } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import CardWrapper from './CardWrapper';
import { CreateTemplateAndEmbedResponse } from '../../../types/marketing';
import useCreateTemplate from '../../../hooks/marketing/useCreateTemplate';

interface Props {
  onSuccess: (result: CreateTemplateAndEmbedResponse) => void | Promise<void>;
  medium: CampaignMedium;
}

function NewTemplateCard({ medium, onSuccess }: Props) {
  const { mutateAsync: createTemplate, isPending } = useCreateTemplate({
    onSuccess: async result => {
      onSuccess?.(result);
    },
    onError: () => {
      toast.error('Failed to create new email template');
    },
  });

  const onClick = async () => {
    await createTemplate(medium);
  };

  return (
    <CardWrapper>
      <LoadingButton
        loading={isPending}
        onClick={onClick}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: 0,
          flexDirection: 'column',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-icon': {
            margin: 0,
          },
        }}
        startIcon={
          <Add
            sx={{
              color: 'primary',
              width: '20px',
            }}
          />
        }>
        <span>Create</span>
      </LoadingButton>
    </CardWrapper>
  );
}

export default NewTemplateCard;
